import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { MOCK_MANUFACTURERS } from "../data";
import { ManufacturerPriorityFilter } from "../types";
import { initialState } from "./initialState";

export const sliceKey = "manufacturerState";

const manufacturerSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getManufacturersList(state) {
      state.loading = false;
      state.error = null;
      state.list = MOCK_MANUFACTURERS;
    },

    setManufacturerPriorityFilter(
      state,
      action: PayloadAction<ManufacturerPriorityFilter>
    ) {
      state.priorityFilter = action.payload;
    },
  },
});

export const { actions: manufacturerActions, reducer } = manufacturerSlice;
